import classNames from "classnames";
import React, { Dispatch, FC, SetStateAction } from "react";
import { FaArrowDown, FaArrowUp } from "react-icons/fa";

import { WorkModel } from "../../../factories/works/models/work.model";
import {
  WorkTableHeaderItem,
  workTableHeaderItems,
  WorkTableSort,
} from "../types/work-table";

type Props = {
  works: WorkModel[];
  archiveWorks?: WorkModel[];
  setArchiveWorks?: Dispatch<SetStateAction<WorkModel[]>>;
  sortBy?: WorkTableSort;
  sortOrder: "asc" | "desc";
  onSortChange?: (sortBy: WorkTableSort, sortOrder: "asc" | "desc") => void;
  showSelection?: boolean;
  headerItems?: WorkTableHeaderItem[];
};

export const WorkTableHeader: FC<Props> = ({
  works,
  archiveWorks,
  setArchiveWorks,
  sortBy,
  sortOrder,
  onSortChange,
  showSelection = true,
  headerItems = workTableHeaderItems,
}) => {
  const handleSortClick = (item: WorkTableHeaderItem) => {
    if (!onSortChange || item.hideSort) return;

    if (sortBy === item.sort) {
      onSortChange(item.sort, sortOrder === "asc" ? "desc" : "asc");
      return;
    }

    onSortChange(item.sort, "asc");
  };

  return (
    <thead className={"border-b border-gray-300"}>
      <tr>
        <th className={"w-[30px] pl-4 pt-2"}>
          {showSelection && (
            <input
              className={
                "checkbox scale-75 rounded-[5px] border-gray-300 [--chkbg:--b1] [--chkfg:--a] checked:border-gray-300 checked:bg-base-100"
              }
              onChange={(e) =>
                setArchiveWorks &&
                (e.target.checked
                  ? setArchiveWorks(works || [])
                  : setArchiveWorks([]))
              }
              checked={(works?.length || 0) === archiveWorks?.length}
              type={"checkbox"}
            />
          )}
        </th>

        {headerItems.map((item) => (
          <th
            key={item.title}
            className={"p-4 text-start text-sm font-semibold text-[#9FA1AD]"}>
            <div
              className={classNames(
                "flex items-center gap-2",
                !item.hideSort && "cursor-pointer",
              )}
              onClick={() => handleSortClick(item)}>
              <div
                className={classNames(
                  "whitespace-nowrap",
                  !item.hideSort && sortBy === item.sort && "text-[#7C66F0]",
                )}>
                {item.title}
              </div>

              {!item.hideSort && sortBy === item.sort && (
                <>
                  {sortOrder === "asc" ? (
                    <FaArrowUp size={8} color={"#7C66F0"} />
                  ) : (
                    <FaArrowDown size={8} color={"#7C66F0"} />
                  )}
                </>
              )}
            </div>
          </th>
        ))}
      </tr>
    </thead>
  );
};
